import { supabase } from './client';

interface ProfileData {
  name?: string;
  job_title?: string;
  avatar_url?: string;
}

interface UserPreferences {
  timezone?: string;
  dateFormat?: string;
  currency?: string;
  language?: string;
}

export async function updateUserProfile(data: ProfileData) {
  const { error } = await supabase.auth.updateUser({
    data: {
      ...data,
      updated_at: new Date().toISOString(),
    },
  });

  if (error) throw error;
}

export async function updateUserPreferences(preferences: UserPreferences) {
  const { data: { user }, error } = await supabase.auth.getUser();
  
  if (error) throw error;
  if (!user) throw new Error('No user found');

  // First try to update existing preferences
  const { error: updateError } = await supabase
    .from('user_preferences')
    .upsert({
      user_id: user.id,
      ...preferences,
      updated_at: new Date().toISOString(),
    });

  if (updateError) throw updateError;

  // Also update user metadata
  const { error: userUpdateError } = await supabase.auth.updateUser({
    data: {
      preferences,
      updated_at: new Date().toISOString(),
    },
  });

  if (userUpdateError) throw userUpdateError;
}

export async function getUserPreferences(): Promise<UserPreferences | null> {
  const { data: { user }, error } = await supabase.auth.getUser();
  
  if (error) throw error;
  if (!user) return null;

  const { data, error: prefsError } = await supabase
    .from('user_preferences')
    .select('*')
    .eq('user_id', user.id)
    .single();

  if (prefsError && prefsError.code !== 'PGRST116') throw prefsError;

  return data || {
    timezone: 'UTC',
    dateFormat: 'DD/MM/YYYY',
    currency: 'GBP',
    language: 'en',
  };
}